import React, { useEffect } from 'react'
import ClientsReviewsSection from './Cards/ClientsReviewsSection'
import ClientHeader from './ClientHeader'
import FeaturedServices from './FeaturedServices'
import FeaturedStylist from './FeaturedStylist'
import AboutBodewrk from './AboutBodewrk'
import HowItWorks from './HowItWorks'
import ViewProfileHistory from './ViewProfileHistory'
import FeaturedText from './FeaturedText'
import ClientFooter from './ClientFooter'

const Home = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  useEffect(() => {
    if (user.user_type === 'client') {
      navigator.geolocation.getCurrentPosition((pos) => {
        if (pos.coords.latitude && pos.coords.longitude) {
          localStorage.setItem(
            'client_location',
            JSON.stringify({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            }),
          )
        }
      })
    }
  }, [])

  return (
    <div style={{ backgroundColor: '#FBF9F9' }}>
      <ClientHeader />
      <div style={{ height: '89vh' }}></div>
      <FeaturedServices />
      <HowItWorks />
      <AboutBodewrk />
      <FeaturedStylist />
      <ClientsReviewsSection />
      <ViewProfileHistory />
      <FeaturedText />
      <ClientFooter />
    </div>
  )
}

export default Home
